<template>
  <div>
    <index-mobile v-if="$resize && $mq.below(767)"></index-mobile>
    <index-desktop v-if="$resize && $mq.above(768)"></index-desktop>
  </div>
</template>

<script>
import IndexMobile from "@/components/IndexPage/IndexMobile.vue";
import IndexDesktop from "@/components/IndexPage/IndexDesktop.vue";
export default {
  components: {
    IndexMobile,
    IndexDesktop
  },
  name: "Index",
  mounted() {
    setTimeout(() => this.$ga.event("Страница", `Главная`, 2), 1000);
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue